import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const ServiceCard = ({ icon: Icon, title, description, index = 0, showLink = true }) => {
    const { t } = useTranslation();

    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="card-hover p-8 group flex flex-col justify-between"
        >
            <div>
                {/* Icon Container */}
                <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <Icon className="text-white" size={28} />
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-gray-800 mb-3 group-hover:text-primary-500 transition-colors">
                    {title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6">
                    {description}
                </p>
            </div>

            {/* Link */}
            {showLink && (
                <div>
                    <Link
                        to="/services"
                        className="inline-flex items-center gap-2 text-primary-500 font-semibold hover:text-accent-500 transition-colors group/link"
                    >
                        <span>{t('common.learnMore')}</span>
                        <FiArrowRight className="rtl:rotate-180 flex-shrink-0" />
                    </Link>
                </div>
            )}
        </motion.div>
    );
};

export default ServiceCard;
